import { z } from 'zod';

export const serviceSchema = z.object({
  id: z.uuid(),
  key: z.string(),
  name: z.string(),
  description: z.string(),
  category: z.enum(['main', 'addon', 'info']),
  duration_minutes: z.number(),
  spans_closed_hours: z.boolean(),
  price_note: z.string().nullable(),
  prices: z.record(z.string(), z.number()),
  bookable: z.boolean(),
});
export type Service = z.infer<typeof serviceSchema>;

const mediaRef = z.object({ url: z.string(), alt: z.string().nullable() }).nullable();

export const publicTenantSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  status: z.enum(['preview', 'live', 'suspended']),
  is_demo: z.boolean(),
  name: z.string(),
  tagline: z.string().nullable(),
  description: z.string(),
  address: z.string(),
  map_url: z.string().nullable(),
  phone: z.string(),
  contacts: z.array(z.object({ type: z.string(), label: z.string(), value: z.string() })),
  timezone: z.string(),
  currency: z.string(),
  locale: z.string(),
  today: z.string(),
  booking_rules: z.object({
    slot_step_minutes: z.number(),
    lead_time_minutes: z.number(),
    horizon_days: z.number(),
    cancel_cutoff_minutes: z.number(),
    require_plate: z.boolean(),
  }),
  branding: z.object({ accent_color: z.string(), theme_color: z.string() }),
  logo: mediaRef,
  hero: mediaRef,
  works: z.array(z.object({ id: z.uuid(), url: z.string(), caption: z.string().nullable(), alt: z.string().nullable(), width: z.number().nullable(), height: z.number().nullable() })),
  cards: z.array(z.object({ position: z.number(), title: z.string(), body: z.string(), icon: z.string() })),
  hours: z.array(z.object({ weekday: z.number(), open_minute: z.number(), close_minute: z.number() })),
  exceptions: z.array(z.object({ day: z.string(), is_closed: z.boolean(), open_minute: z.number().nullable(), close_minute: z.number().nullable(), note: z.string().nullable() })),
  vehicle_classes: z.array(z.object({ id: z.uuid(), key: z.string(), name: z.string(), description: z.string().nullable() })),
  resources_count: z.number(),
  services: z.array(serviceSchema),
});
export type PublicTenant = z.infer<typeof publicTenantSchema>;
